import React, { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";

export default function Header({ onQuoteClick }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handler);
    return () => window.removeEventListener("scroll", handler);
  }, []);

  const links = [
    { href: "#services", label: "Services" },
    { href: "#gallery", label: "Work" },
    { href: "#testimonials", label: "Reviews" },
    { href: "#area", label: "Service Area" },
    { href: "#contact", label: "Contact" },
  ];

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-colors ${
        scrolled ? "bg-[#0D0D0D]/95 backdrop-blur" : "bg-transparent"
      } border-b border-[#333]/60`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <a href="#top" data-testid="brand-logo" className="flex items-center gap-3">
          <div className="w-10 h-10 bg-[#FF5A00] flex items-center justify-center font-heading text-black text-xl">
            TD
          </div>
          <div className="leading-none">
            <div className="font-heading text-white text-2xl tracking-wide uppercase">TradesmanDan</div>
            <div className="text-[10px] tracking-[0.3em] text-[#A3A3A3] uppercase">Fencing · SE VIC + Gippsland</div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(" ", "-")}`}
              className="text-sm tracking-[0.2em] uppercase text-white/80 hover:text-[#FF5A00] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <a
            href="mailto:Tradesmandanvic@gmail.com"
            className="hidden xl:flex items-center gap-2 text-sm text-white/70 hover:text-white"
          >
            <Phone className="w-4 h-4 text-[#FF5A00]" />
            <span className="tracking-wider">QUOTE BY EMAIL</span>
          </a>
          <button
            data-testid="header-quote-btn"
            onClick={onQuoteClick}
            className="bg-[#FF5A00] text-black font-heading tracking-widest uppercase px-6 py-3 hover:bg-[#E65100] transition-colors text-sm"
          >
            Get Free Quote
          </button>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="lg:hidden text-white p-2"
          aria-label="Toggle menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#0D0D0D] border-t border-[#333]">
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-base tracking-[0.2em] uppercase text-white/80"
              >
                {l.label}
              </a>
            ))}
            <button
              data-testid="mobile-quote-btn"
              onClick={() => {
                setOpen(false);
                onQuoteClick();
              }}
              className="bg-[#FF5A00] text-black font-heading tracking-widest uppercase px-6 py-3 mt-2"
            >
              Get Free Quote
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
